// Vue
import Vue from "vue";
// Vuex store
import { RootState } from "..";
import { GetterTree, MutationTree, ActionTree, Module } from "vuex";

import {
  CustomerModel,
  CustomersClient,
  CustomerFilterSort,
  CustomerSortField,
  UpdateCustomerModel
} from "@/core/api/apiClient";

class CustomersState {
  items: CustomerModel[] | undefined = undefined;
}

export const state: CustomersState = {
  items: undefined
};

const namespaced: boolean | undefined = true;

const getters = {
  items(state) {
    if (!state.items) return [];

    return state.items.sort((a, b) => (a.name < b.name ? -1 : 1));
  },
  item:
    (state) =>
    (CustomerId: string): CustomerModel | undefined => {
      if (!state.items) {
        return undefined;
      }

      const customer = state.items.find((x) => x.customerId == CustomerId);

      return customer;
    }
} as GetterTree<CustomersState, any>;

const mutations = {
  SET_CUSTOMERS(state, customers: CustomerModel[]) {
    state.items = customers;
  },
  UPDATE_CUSTOMER(state, customer: CustomerModel) {
    if (!state.items) return;

    const existingItem = state.items.findIndex((x) => x.customerId === customer.customerId);

    if (existingItem !== -1) {
      Vue.set(state.items, existingItem, customer);
    } else {
      state.items.push(customer);
    }
  },
  REMOVE_CUSTOMER(state, CustomerId: string) {
    if (state.items != undefined) {
      state.items = state.items?.filter((x) => x.customerId != CustomerId);
    }
  }
} as MutationTree<CustomersState>;

const actions = {
  async fetchCustomers({ commit, rootState }) {
    let data = Array<CustomerModel>();
    const customerClient = new CustomersClient();

    const filter = new CustomerFilterSort({
      sortField: CustomerSortField.Name,
      sortDescending: false,
      clientId: rootState.currentUser.client.clientId
    });

    await customerClient.listForClient(filter).then((result) => {
      data = result.model;
      commit("SET_CUSTOMERS", data);
    });
  },
  pushCustomers({ commit, rootState }): any {
    const customers = rootState.customers.items;

    customers.forEach((customer: CustomerModel) => {
      commit("UPDATE_CUSTOMER", customer);
    });
  },
  async setCustomer({ commit, rootState }, customer: CustomerModel): Promise<any> {
    const customerClient = new CustomersClient();

    const updateModel = new UpdateCustomerModel({
      name: customer.name,
      phone: customer.phone,
      ext: customer.ext,
      email: customer.email,
      businessAddress: customer.businessAddress,
      notes: customer.notes,
      isCOD: customer.isCOD,
      lastUsedTimestamp: customer.lastUsedTimestamp
    });

    if (customer.customerId === undefined || customer.customerId === "") {
      return await customerClient
        .addCustomer(rootState.currentUser.client.clientId, updateModel)
        .then((data) => {
          commit("UPDATE_CUSTOMER", data.model);
          return data.model;
        });
    } else {
      return await customerClient
        .updateCustomer(rootState.currentUser.client.clientId, customer.customerId, updateModel)
        .then((data) => {
          commit("UPDATE_CUSTOMER", data.model);
          return data.model;
        });
    }
  },
  async removeCustomer({ commit, rootState }, customer: CustomerModel): Promise<any> {
    const customerClient = new CustomersClient();

    await customerClient
      .deleteCustomer(rootState.currentUser.client.clientId, customer.customerId)
      .then(() => {
        commit("REMOVE_CUSTOMER", customer.customerId);
      });
  }
} as ActionTree<CustomersState, any>;

export const customers: Module<CustomersState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
